<template>
  <Table ref="table" :columns="columns" :data="list" :max-height="700">
    <template slot-scope="{ row }" slot="status">
      <a>{{ row.status }}</a><br>
      <a class="scoped-error">{{ row.breakdown }}</a>
    </template>
    
    <template slot-scope="{ row }" slot="status_time">
      {{ row.status_time }}<br>
      {{ row.breakdown_time }}
    </template>
  </Table>
</template>
<script>
export default {
  props: {
    list: Array
  },
  data() {
    return {
      columns: [
        {
          title: this.$t("name.cex.query.code"),
          key: 'code',
          width: 200
        },
        {
          title: this.$t("name.cex.query.status"),
          slot: 'status'
        },
        {
          title: this.$t("name.cex.query.status_time"),
          slot: 'status_time'
        }
      ],
    };
  },
};
</script>
<style lang="less" scoped>
  @import '@/style/app.less';
  
  .scoped-error{
    color: @color-error;
  }
    
</style>